import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PERMISSIONS } from '@auth/permissions';
import { AuthGuard, PermissionGuard } from '@auth/services';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    data: {
      requiredPermissions: [PERMISSIONS.WSINVINQUIRE],
    },
    loadChildren: () => import('@inventory/inquiry/inquiry.module').then((m) => m.InquiryModule),
    canActivate: [AuthGuard, PermissionGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'item-detail',
    data: {
      breadcrumb: { label: 'core.breadcrumbs.inventory.detail.label' },
      requiredPermissions: [PERMISSIONS.WSINVINQUIRE],
    },
    loadChildren: () => import('@inventory/item-detail/detail.module').then((m) => m.DetailModule),
    canActivate: [AuthGuard, PermissionGuard],
    runGuardsAndResolvers: 'always',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InventoryRoutingModule {}
